
const collectMaxCreatedAt = (node, state) => {
  if (node == null) return;
  if (Array.isArray(node)) {
    for (const item of node) collectMaxCreatedAt(item, state);
    return;
  }
  if (typeof node !== "object") return;


  for (const key in node) {
    if (!key.startsWith("createdAt")) continue;
    const raw = node[key];
    if (typeof raw !== "string" || !raw) continue;
    const ts = Date.parse(raw);
    if (!Number.isNaN(ts) && ts > state.max) state.max = ts;
  }

  for (const key in node) {
    if (key.startsWith("createdAt")) continue;
    collectMaxCreatedAt(node[key], state);
  }
};

export const extractUpdatedAt = (source, fallback = "-") => {
  const state = { max: -Infinity };
  collectMaxCreatedAt(source, state);
  if (state.max === -Infinity) return fallback;
  const d = new Date(state.max);
  const data = d.toLocaleDateString("pt-BR");
  const hora = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  return `${data} às ${hora}`;
};

export default extractUpdatedAt;
